/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_viewer = {
    readonly isPopularSearchesEnabled: boolean | null;
    readonly " $refType": "SharedRespLinksBlock_viewer";
};
export type SharedRespLinksBlock_viewer$data = SharedRespLinksBlock_viewer;
export type SharedRespLinksBlock_viewer$key = {
    readonly " $data"?: SharedRespLinksBlock_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_viewer",
  "selections": [
    {
      "alias": "isPopularSearchesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "popularSearches"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"popularSearches\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '833762a6a2e47222ba83b8fb2f8153f2';
export default node;
